import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const MapMarkerIcon: IconComponent = ({ className, colorCode = 'black', width = 23, height = 32 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 23 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.5 0C5.15887 0 0 5.19888 0 11.5891C0 19.5196 10.2914 31.1621 10.7295 31.6538C11.1411 32.1158 11.8596 32.1149 12.2705 31.6538C12.7086 31.1621 23 19.5196 23 11.5891C22.9999 5.19888 17.8411 0 11.5 0ZM11.5 17.4199C8.30962 17.4199 5.71412 14.8043 5.71412 11.5891C5.71412 8.374 8.30968 5.75838 11.5 5.75838C14.6903 5.75838 17.2858 8.37407 17.2858 11.5892C17.2858 14.8043 14.6903 17.4199 11.5 17.4199Z"
                fill={color}
            />
            <ellipse cx="11.5468" cy="11.6365" rx="5.77341" ry="5.81818" fill="white" />
        </svg>
    )
}
